import { create } from 'zustand';

export type ToastKind = 'error' | 'success' | 'info';

export type Toast = {
  id: number;
  kind: ToastKind;
  text: string;
};

type ToastState = {
  items: Toast[];
  push: (t: { kind: ToastKind; text: string }) => void;
  dismiss: (id: number) => void;
};

const AUTO_DISMISS_MS = 6000;
let nextId = 1;

/**
 * Store, e não hook: o queryClient precisa emitir toast e é módulo, não componente.
 * Mesmo padrão do authStore.
 */
export const useToastStore = create<ToastState>((set, get) => ({
  items: [],
  push: ({ kind, text }) => {
    // Erros repetidos (ex.: várias queries falhando de uma vez com a API fora do ar)
    // viram uma linha só em vez de empilhar a mesma mensagem N vezes.
    if (get().items.some((i) => i.text === text && i.kind === kind)) return;

    const id = nextId++;
    set((s) => ({ items: [...s.items, { id, kind, text }] }));
    if (typeof window !== 'undefined') {
      window.setTimeout(() => get().dismiss(id), AUTO_DISMISS_MS);
    }
  },
  dismiss: (id) => set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
}));

export const toast = {
  error: (text: string) => useToastStore.getState().push({ kind: 'error', text }),
  success: (text: string) => useToastStore.getState().push({ kind: 'success', text }),
  info: (text: string) => useToastStore.getState().push({ kind: 'info', text }),
};
